import Settings from "./Settings";
import { AuthToken } from "./AuthToken";

import ProcessingResult from "../framework/ProcessingResult";

import SendMessageResult from "../classes/dtos/assistantmodule/SendMessageResult";
import CreateChatSessionResult from "../classes/dtos/assistantmodule/CreateChatSessionResult";
import ChatMessageDto from "../classes/dtos/assistantmodule/ChatMessageDto";

const AIAssistantApi = {

    GetAIAssistantSessionsAsync: async function (aiGroupId: number | null): Promise<ProcessingResult<number[]>> {
        let authSession = await AuthToken.get();

        let parameters = '';

        if (aiGroupId !== null) {
            parameters += "aiGroupId=" + aiGroupId.toString();
        }

        if (parameters.length > 0) {
            parameters = "?" + parameters;
        }

        const response = await fetch(Settings.api_url + "/AIAssistant/GetAIAssistantSessions" + parameters, {
            method: "get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.sessionIds);
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    GetAIAssistantMessagesAsync: async function (chatSessionId: number): Promise<ProcessingResult<ChatMessageDto[]>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIAssistant/GetAIAssistantMessages?ChatSessionId=" + chatSessionId.toString(), {
            method: "get",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            }
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(data.messages.map((e: any) => new ChatMessageDto(e.role, e.content)));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    CreateChatSessionAsync: async function (aiGroupId: number | null): Promise<ProcessingResult<CreateChatSessionResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIAssistant/CreateChatSession", {
            method: "post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ AIGroupId: aiGroupId })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new CreateChatSessionResult(data.id));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    },

    SendMessageAsync: async function (sessionId: number, message: string): Promise<ProcessingResult<SendMessageResult>> {
        let authSession = await AuthToken.get();

        const response = await fetch(Settings.api_url + "/AIAssistant/SendMessage", {
            method: "post",
            mode: "cors",
            cache: "no-cache",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Authorization": "Bearer " + authSession.Token
            },
            body: JSON.stringify({ SessionId: sessionId, Message: message })
        });

        if (response.status === 200) {
            let data = await response.json();
            return ProcessingResult.Ok(new SendMessageResult(data.sessionId, data.messages));
        }

        return ProcessingResult.Error("Error = " + response.status.toString());
    }
};

export default AIAssistantApi;